import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { LocationDTO } from "src/app/features/locations-map/models/LocationDTO";
@Injectable({
  providedIn: "root",
})
export class LocationsAPIService implements IApiBase{
  
  private configUrl = "";
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  recalculateCoordsProcess() {
    console.log("/api/Location/recalculateCords/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/recalculateCords",
      {}
    );
  }

  GetLayerGPSGeoJson(){
    console.log("/api/Location/GetLayerGPSGeoJson/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetLayerGPSGeoJson",
      {}
    )}

  GetLayerByIdLocationCategoryGeoJSON( IdLocationCategory : number){
    console.log(this.configUrl + "/api/LocationCategory/GetLayerByIdLocationCategoryGeoJSON");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Location/GetLayerByIdLocationCategoryGeoJSON?IdLocationCategory="+IdLocationCategory)
  }

  setLocationsGeoJsonFilter(filters: any):any{
    console.log("/api/Location/GetGeoJsonFilter/");
    return this.http.post<EstatusJSON>( this.configUrl + "/api/Location/GetGeoJsonFilter",filters);
  }

  GetGeoJsonAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]):any{
    const avalabilityFiltersRequest = { idLocationCategories: idLocationCategories, initialDate: initialDate, finalDate: finalDate, filtersRequest: filters };
    console.log("/api/Location/GetGeoJsonAvailabilityFilter/");
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Location/GetGeoJsonAvailabilityFilter",avalabilityFiltersRequest)
  }

  getByIdentifier(identifier): any {
    console.log("/api/Location/GetByIdentifier/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetByIdentifier?identifier=" + identifier,
      {}
    );
  }
  postValidateIdentifiers(identifiers: string[], client: string = ""): any {
    console.log("/api/Location/postValidateIdentifiers/", client);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Location/postValidateIdentifiers?client=" + client,
      identifiers
    );
  }
  getLastOdometer(identifier): any {
    console.log("/api/Location/GetLastOdometer/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetLastOdometer?identifier=" + identifier,
      {}
    );
  }

  updateLocationOdometer( identifier, kilometraje: number): any {
    console.log("/api/Location/UpdateOdometer");
     return this.http.get<any>(this.configUrl + "/api/Location/UpdateOdometer?identifier="+identifier+"&&kilometraje="+kilometraje, {})
  }

  getDataNames(keyNames: any) {
    console.log("/api/Location/GetDataNames/");
    return this.http.post<EstatusJSON>( this.configUrl + "/api/Location/GetDataNames",keyNames,{});
  }

  getListByGroups( customerGroups: any ): any {
    console.log("/api/Location/GetListByGroups/", customerGroups);
    
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Location/GetListByGroups", customerGroups);
  }

  CreateOrUpdateLocationProperty(identifier: string, keyName: string, keyValue: string): any {
    return this.http.get<EstatusJSON>( this.configUrl + "/api/Location/CreateOrUpdateLocationProperty?identifier="+identifier+"&keyName="+keyName+"&keyValue="+keyValue, {});
  }

  getList(): any {
    console.log("/api/Location/GetList/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetList",
      {}
    );
  }

  getByClientList(client: string, groupList = "", subGroupList = ""): any {
    console.log("/api/Location/GetListByClient/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListByClient?client=" + client + "&groupList=" + groupList + "&subGroupList=" + subGroupList,
      {}
    );
  }

  findByIdentifier(identifier): any {
    console.log("/api/Location/FindByIdentifier/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/FindByIdentifier?identifier=" + identifier,
      {}
    );
  }

  getListFilter(filtersRequest : any[]): any {
    console.log("/api/Location/GetListFilter");
     return this.http.post<any>(this.configUrl + "/api/Location/GetListFilter", filtersRequest)
  }

  getListFilterTab(filtersRequest : any[], tipoTab: string, finder: string, idLocationCategory: number): any {
    console.log("/api/Location/GetListFilterTab", filtersRequest);
     return this.http.post<any>(this.configUrl + "/api/Location/GetListFilterTab?tipoTab=" + tipoTab+"&finder=" + finder + "&idLocationCategory=" + idLocationCategory, filtersRequest)
  }

  findUpdatedByIdentifier(identifier, tipo): any {
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/Location/FindUpdatedByIdentifier?identifier=" + identifier+"&tipo=" + tipo, {} );
  }
  FindAllByIdentifier(identifier): any {
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/Location/FindAllByIdentifier?identifier=" + identifier, {} );
  }

  GetCountListActualizados(filters: any[]): any {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Location/GetCountListActualizados",
      filters
    );
  }

  GetCountListDesactualizados(filters: any[]): any {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Location/GetCountListDesactualizados",
      filters
    );
  
  }
  GetCountListSinReporte(filters: any[]): any {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Location/GetCountListSinReporte",
      filters
    );
  }

  GetCountByIdLocationCategory(idLocationCategory: number, filters: any[]) {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Location/GetCountByIdLocationCategory?IdLocationCategory="+idLocationCategory,
      filters
    );
  }

  GetListDesactualizados(): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListDesactualizados",
      {}
    );
  
  }

  GetListByIdLocationCategory(idLocationCategory: number): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListByIdLocationCategory?idLocationCategory="+ idLocationCategory,
      {}
    );
  }


  GetListActualizadosPage(page:number): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListActualizadosPage?page="+ page,
      {}
    );
  }

  GetListDesactualizadosPage(page:number): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListDesactualizadosPage?page="+ page,
      {}
    );
  
  }
  GetListSinReportePage(page:number): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListSinReportePage?page="+ page,
      {}
    );
  }

  GetListByIdLocationCategoryPage(idLocationCategory: number, page:number): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetListByIdLocationCategoryPage?idLocationCategory="+ idLocationCategory+"&page="+ page,
      {}
    );
  }

   postLocationsTabToExcel(selectedTab: string, idLocationCategory: number, finder: string, filtersRequest : any[]): any {
    console.log("PostLocationsTabToExcel", selectedTab, idLocationCategory, finder, filtersRequest);
      filtersRequest = filtersRequest || [];
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post<any>(this.configUrl + "/api/Location/PostLocationsTabToExcel?selectedTab=" + selectedTab + "&idLocationCategory=" + idLocationCategory + "&finder=" + finder, filtersRequest, { headers });
    }
  
    postLocationsVinListToExcel(listaVin: LocationDTO[]): any {
      return this.http.post<any>(this.configUrl + "/api/Location/PostLocationsVinListToExcel", listaVin);
    }

  GetRouteSheet(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean): any {
    console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, idLocationCategoryChild);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetRouteSheet?parentIdentifier=" + parentIdentifier + "&idLocationCategory=" + idLocationCategoryChild + "&filter=" + filter + "&includeGeojson=" + includeGeojson + "&calculateByDistance=" + orderValue + "&isForcedReload=" + isForcedReload, {}
    );
  }

  GetRouteSheetPage(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean, page: number): any {
    console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, idLocationCategoryChild);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetRouteSheetPage?parentIdentifier=" + parentIdentifier + "&idLocationCategory=" + idLocationCategoryChild + "&filter=" + filter + "&includeGeojson=" + includeGeojson + "&calculateByDistance=" + orderValue + "&isForcedReload=" + isForcedReload + "&page=" + page, {}
    );
  }

}
